import EmdEnumValueListView from "@/views/manager/EmdEnumValueListView.vue";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import api from "@/api";
export default {
  name: "SiteSpyView",
  components: {
    BatterTableDataView,
    EmdEnumValueListView
  },
  data() {
    return {
      curNav: 0,
      permissions: [],
      navs: ['竞对站点', '更新监控']
    };
  },
  methods: {
    viewPage(p) {
      window.open(p.url, "_blank");
    },
    init() {
      api.getUserInfo().then(ret => {
        this.permissions = ret.permissions;
      });
    }
  },
  mounted() {
    this.init();
  }
};